import { render, staticRenderFns } from "./roleTable.vue?vue&type=template&id=055cfd10&scoped=true"
import script from "./roleTable.vue?vue&type=script&lang=js"
export * from "./roleTable.vue?vue&type=script&lang=js"
import style0 from "./roleTable.vue?vue&type=style&index=0&id=055cfd10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055cfd10",
  null
  
)

export default component.exports